export const title = {
  es: "Validá tu dirección de mail",
  en: "Validate your email address",
};

export const subtitle = {
  es: "El código es válido durante 24 horas",
  en: "The code is valid for 24 hours",
};

export const success = {
  es: "Ingresá el token que enviamos a",
  en: "Enter the token we sent to",
};

export const primaryButton = {
  es: "Guardar y Continuar",
  en: "Save and Continue",
};

export const secondaryButton = {
  es: "Volver",
  en: "Back",
};

export const errors = {
  invalidToken: {
    es: "El token ingresado es incorrecto. Verificalo e intentá nuevamente.",
    en: "The entered token is incorrect. Please verify and try again.",
  },
  expiredToken: {
    es: "El token ha expirado. Solicitá uno nuevo para continuar.",
    en: "The token has expired. Please request a new one to continue.",
  },
  maxAttempts: {
    es: "Superaste el número máximo de intentos permitidos. Por seguridad, generá un nuevo token.",
    en: "You have exceeded the maximum number of attempts allowed. For security reasons, please generate a new token.",
  },
  generic: {
    es: "Error al autorizar el token.",
    en: "Error authorizing the token.",
  }
};
